import React from 'react';

import { SVGComponentProps } from './svg.types';

const CheckSVG = ({
  fill = 'white',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block align-middle ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 12"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M3.9731 10.774L0.500097 7.30002C0.340782 7.14084 0.214398 6.95183 0.12817 6.74378C0.0419412 6.53573 -0.00244141 6.31273 -0.00244141 6.08752C-0.00244141 5.86231 0.0419412 5.63931 0.12817 5.43126C0.214398 5.22322 0.340782 5.0342 0.500097 4.87502C0.821836 4.55376 1.25792 4.37331 1.7126 4.37331C2.16727 4.37331 2.60336 4.55376 2.9251 4.87502L5.1001 7.04802C5.14394 7.09162 5.20326 7.1161 5.2651 7.1161C5.32693 7.1161 5.38625 7.09162 5.4301 7.04802L11.0701 1.40802C11.3918 1.08676 11.8279 0.906311 12.2826 0.906311C12.7373 0.906311 13.1734 1.08676 13.4951 1.40802C13.6544 1.5672 13.7808 1.75621 13.867 1.96426C13.9533 2.17231 13.9976 2.39531 13.9976 2.62052C13.9976 2.84573 13.9533 3.06873 13.867 3.27678C13.7808 3.48483 13.6544 3.67384 13.4951 3.83302L6.5551 10.774C6.21267 11.1164 5.7483 11.3087 5.2641 11.3087C4.7799 11.3087 4.31552 11.1164 3.9731 10.774Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default CheckSVG;
